"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidDatasheetFileError = exports.DatasheetFileOwnerMismatchError = exports.DatasheetDownloadFailedError = exports.DatasheetFileNotFoundError = exports.PackageFamilyPrefixMismatchError = exports.PackageAlreadyExistsError = exports.PackageFamilyNotFoundError = void 0;
exports.isPackageFamilyNotFoundError = isPackageFamilyNotFoundError;
exports.isPackageAlreadyExistsError = isPackageAlreadyExistsError;
exports.isPackageFamilyPrefixMismatchError = isPackageFamilyPrefixMismatchError;
exports.isDatasheetFileNotFoundError = isDatasheetFileNotFoundError;
exports.isDatasheetDownloadFailedError = isDatasheetDownloadFailedError;
exports.isDatasheetFileOwnerMismatchError = isDatasheetFileOwnerMismatchError;
exports.isInvalidDatasheetFileError = isInvalidDatasheetFileError;
class PackageFamilyNotFoundError extends Error {
    constructor(packageFamilyId) {
        super(`PackageFamily not found: ${packageFamilyId}`);
        this.name = this.constructor.name;
        this.packageFamilyId = packageFamilyId;
    }
}
exports.PackageFamilyNotFoundError = PackageFamilyNotFoundError;
function isPackageFamilyNotFoundError(error) {
    return error instanceof PackageFamilyNotFoundError;
}
class PackageAlreadyExistsError extends Error {
    constructor(args) {
        super(`A package with manufacturerPartNumber='${args.manufacturerPartNumber}', ` +
            `variantSuffix='${args.variantSuffix}', manufacturerId='${args.manufacturerId}', ` +
            `ownerId='${args.ownerId}' already exists. To create a new package, change one of: ` +
            `manufacturerPartNumber, variantSuffix, manufacturerName, or owner.`);
        this.name = this.constructor.name;
        this.manufacturerPartNumber = args.manufacturerPartNumber;
        this.variantSuffix = args.variantSuffix;
        this.manufacturerId = args.manufacturerId;
        this.ownerId = args.ownerId;
    }
}
exports.PackageAlreadyExistsError = PackageAlreadyExistsError;
function isPackageAlreadyExistsError(error) {
    return error instanceof PackageAlreadyExistsError;
}
class PackageFamilyPrefixMismatchError extends Error {
    constructor(args) {
        super(`PackageFamily '${args.familyName}' (id='${args.packageFamilyId}') is not a ` +
            `case-insensitive prefix of MPN '${args.mpn}'.`);
        this.name = this.constructor.name;
        this.packageFamilyId = args.packageFamilyId;
        this.familyName = args.familyName;
        this.mpn = args.mpn;
    }
}
exports.PackageFamilyPrefixMismatchError = PackageFamilyPrefixMismatchError;
function isPackageFamilyPrefixMismatchError(error) {
    return error instanceof PackageFamilyPrefixMismatchError;
}
class DatasheetFileNotFoundError extends Error {
    constructor(fileId) {
        super(`Datasheet file not found: ${fileId}`);
        this.name = this.constructor.name;
        this.fileId = fileId;
    }
}
exports.DatasheetFileNotFoundError = DatasheetFileNotFoundError;
function isDatasheetFileNotFoundError(error) {
    return error instanceof DatasheetFileNotFoundError;
}
class DatasheetDownloadFailedError extends Error {
    constructor(url) {
        super(`Could not download a datasheet from ${url}. The site may be blocking automated downloads — try uploading the file directly instead.`);
        this.name = this.constructor.name;
        this.url = url;
    }
}
exports.DatasheetDownloadFailedError = DatasheetDownloadFailedError;
function isDatasheetDownloadFailedError(error) {
    return error instanceof DatasheetDownloadFailedError;
}
class DatasheetFileOwnerMismatchError extends Error {
    constructor(args) {
        const packageOwnerDescription = args.packageOwnerId === null ? 'publicly owned' : `owned by '${args.packageOwnerId}'`;
        const packageDescription = args.packageId === null ? 'the candidate package' : `package '${args.packageId}'`;
        super(`File '${args.fileId}' is owned by '${args.fileOwnerId}' but ${packageDescription} is ` +
            `${packageOwnerDescription}. Pass a public (non-owned) file, or one owned by the same tenant.`);
        this.name = this.constructor.name;
        this.fileId = args.fileId;
        this.fileOwnerId = args.fileOwnerId;
        this.packageId = args.packageId;
        this.packageOwnerId = args.packageOwnerId;
    }
}
exports.DatasheetFileOwnerMismatchError = DatasheetFileOwnerMismatchError;
function isDatasheetFileOwnerMismatchError(error) {
    return error instanceof DatasheetFileOwnerMismatchError;
}
class InvalidDatasheetFileError extends Error {
    constructor(fileName) {
        super(`The file "${fileName}" is not a valid PDF. Please upload a PDF datasheet.`);
        this.name = this.constructor.name;
        this.fileName = fileName;
    }
}
exports.InvalidDatasheetFileError = InvalidDatasheetFileError;
function isInvalidDatasheetFileError(error) {
    return error instanceof InvalidDatasheetFileError;
}
//# sourceMappingURL=package.errors.js.map